<script setup lang="ts">
import { GesuchStatus } from '@/models/Gesuch'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps({
    status: {
        type: [String, null],
        default: null,
    },
    badge: {
        type: Boolean,
        default: false,
    },
})

const { t } = useI18n()

const statusText = computed(() => {
    switch (props.status) {
        case GesuchStatus.AB_APPROVED:
            return t('apollon_status_ab_approved')
        case GesuchStatus.AB_CANCELED:
            return t('apollon_status_ab_canceled')
        case GesuchStatus.AB_IN_PROGRESS:
            return t('apollon_status_ab_in_progress')
        case GesuchStatus.AB_INCOMPLETE:
            return t('apollon_status_ab_incomplete')
        case GesuchStatus.AB_REJECTED:
            return t('apollon_status_ab_rejected')
        case GesuchStatus.AB_SUBMIT:
            return t('apollon_status_ab_submit')
        case GesuchStatus.APPROVED:
            return t('apollon_status_approved')
        case GesuchStatus.AB_READY_FOR_SUBMIT:
            return t('apollon_status_ab_ready_for_submit')
        case GesuchStatus.CANCELED:
            return t('apollon_status_canceled')
        case GesuchStatus.CLOSED:
            return t('apollon_status_closed')
        case GesuchStatus.IN_PROGRESS:
            return t('apollon_status_in_progress')
        case GesuchStatus.INCOMPLETE:
            return t('apollon_status_incomplete')
        case GesuchStatus.NEW:
            return t('apollon_status_new')
        case GesuchStatus.READY_FOR_SUBMIT:
            return t('apollon_status_ready_for_submit')
        case GesuchStatus.REJECTED:
            return t('apollon_status_rejected')
        case GesuchStatus.SUBMIT:
            return t('apollon_status_submit')
        default:
            return `(${t('apollon_status_' + props.status)})`
    }
})
</script>

<template>
    <span :class="['status', 'text-no-wrap', status, badge ? 'badge' : '']">{{ statusText }}</span>
</template>

<style lang="scss" scoped>
.status {
    font-size: 1em;
    &.new {
        color: red;
    }
    &.ab_approved {
        color: rgb(96, 187, 96);
    }
    &.ab_canceled {
        color: rgb(190, 167, 32);
    }
    &.ab_in_progress {
        color: rgb(190, 167, 32);
    }
    &.ab_incomplete {
        color: red;
    }
    &.ab_rejected {
        color: red;
    }
    &.ab_submit {
        color: rgb(96, 187, 96);
    }
    &.approved {
        color: rgb(96, 187, 96);
    }
    &.canceled {
        color: rgb(190, 167, 32);
    }
    &.closed {
        color: rgb(96, 187, 96);
    }
    &.in_progress {
        color: rgb(190, 167, 32);
    }
    &.incomplete {
        color: red;
    }
    &.ready_for_submit {
        color: rgb(190, 167, 32);
    }
    &.ab_ready_for_submit {
        color: rgb(190, 167, 32);
    }
    &.rejected {
        color: red;
    }
    &.submit {
        color: rgb(96, 187, 96);
    }
    &.badge {
        color: white;
        text-shadow: 1px 1px 0 #464646;
        border-radius: 1em;
        padding: 0.1em 0.4em;
        line-height: 1em;
        vertical-align: middle;
        &.new {
            background-color: red;
        }
        &.ab_approved {
            background-color: rgb(96, 187, 96);
        }
        &.ab_canceled {
            background-color: rgb(190, 167, 32);
        }
        &.ab_in_progress {
            background-color: rgb(190, 167, 32);
        }
        &.ab_incomplete {
            background-color: red;
        }
        &.ab_rejected {
            background-color: red;
        }
        &.ab_submit {
            background-color: rgb(96, 187, 96);
        }
        &.approved {
            background-color: rgb(96, 187, 96);
        }
        &.canceled {
            background-color: rgb(190, 167, 32);
        }
        &.closed {
            background-color: rgb(96, 187, 96);
        }
        &.in_progress {
            background-color: rgb(190, 167, 32);
        }
        &.incomplete {
            background-color: red;
        }
        &.ready_for_submit {
            background-color: rgb(190, 167, 32);
        }
        &.ab_ready_for_submit {
            background-color: rgb(190, 167, 32);
        }
        &.rejected {
            background-color: red;
        }
        &.submit {
            background-color: rgb(96, 187, 96);
        }
    }
}
</style>
